/**
 * Class for Application Lifecycle
 */
export class ApplicationLifecycle {
  public static PRE_DECISION = 'PRE_DECISION'; // part of RUW flow
  public static POST_DECISION = 'POST_DECISION'; // part of RUW flow
  public static PIA = 'PIA';
  public static RHO = 'RHO';
  public static COMPLETED = 'COMPLETED';
  public static AUDIT = 'AUDIT';
  public static CARRIERS_REVIEW = 'CARRIERS_REVIEW'; // CLR
  public static FINAL_AUDIT_REVIEW = 'FINAL_AUDIT_REVIEW'; // CLR
  public static HOLDING_FOR_RESCISSION = 'HOLDING_FOR_RESCISSION'; // CLR
  public static RESCINDED = 'RESCINDED';
  public static REINSTATEMENT = 'REINSTATEMENT';
  public static CLR = 'CLR';
  public static RUW = 'RUW';
  public static PLAN_F = 'PLAN_F';
  public static INVESTIGATION = 'INVESTIGATION';
}

export const LifecycleColorMap: Record<string, string> = {
  PRE_DECISION: 'OliveDrab',
  POST_DECISION: 'DarkGreen',
  PIA: 'Neutral',
  RHO: 'Neutral',
  COMPLETED: 'MediumSeaGreen',
  AUDIT: 'NoraPink',
  CARRIERS_REVIEW: 'DodgerBlue',
  FINAL_AUDIT_REVIEW: 'DarkBlue',
  HOLDING_FOR_RESCISSION: 'Coral',
  RESCINDED: 'DarkScarlet',
  REINSTATEMENT: 'DarkBlue',
  RUW: 'Maroon',
  INVESTIGATION: 'DarkViolet',
};

export const RUWLifecycles = [
  ApplicationLifecycle.PRE_DECISION,
  ApplicationLifecycle.POST_DECISION,
];

export const PIALifecycles = [
  ApplicationLifecycle.PIA,
  ApplicationLifecycle.COMPLETED,
];
